/**
 * Tipos EXACTOS del contrato de la API de análisis.
 * Incluye:
 *  - Query params (obligatorios y opcionales)
 *  - DTOs de respuesta para los 4 endpoints
 */

/* =========================
 *  QUERY PARAMS (REQUEST)
 * ========================= */

export type GuideIdApi = string;     // ej: "guia-iii"
export type CampaignIdApi = string;  // ej: "beea4356-b121-45ce-8823-16f1b147b4ac"

/** Parámetros obligatorios comunes a los 4 endpoints */
export interface AnalysisQueryRequired {
  guideId: GuideIdApi;
  campaign: CampaignIdApi;
}

/** Filtros demográficos opcionales (coinciden con tus respuestas) */
export interface AnalysisDemographicFilters {
  gender?: string;
  ageRange?: string;
  department?: string;
  educationLevel?: string;
  position?: string;
  employeeType?: string;
  seniority?: string;
  contractType?: string;
  maritalStatus?: string;
  educationStatus?: string;
  occupation?: string;
  workSchedule?: string;
  hasShiftRotation?: boolean;
  totalWorkExperience?: string;
}

/** Nueva interfaz para agrupar */
export interface GroupableRequest {
  groupBy?: string | string[];
}

/** Requests por endpoint (comparten mismos params) */
export type CategoryScoresRequest   = AnalysisQueryRequired & AnalysisDemographicFilters & GroupableRequest;
export type DomainScoresRequest     = AnalysisQueryRequired & AnalysisDemographicFilters & GroupableRequest;
export type DimensionScoresRequest  = AnalysisQueryRequired & AnalysisDemographicFilters & GroupableRequest;
export type FinalAssessmentsRequest = AnalysisQueryRequired & AnalysisDemographicFilters;

/* =========================
 *  RESPONSES (DTOs API)
 * ========================= */

export interface DemographicBreakdownDto {
  gender: string | null;
  ageRange: string | null;
  department: string | null;
  educationLevel: string | null;
  position: string | null;
  employeeType: string | null;
  seniority: string | null;
  contractType: string | null;
  maritalStatus: string | null;
  educationStatus: string | null;
  occupation: string | null;
  workSchedule: string | null;
  hasShiftRotation: boolean | null;
  totalWorkExperience: string | null;
}

/** /analysis/category-scores */
export interface AggregatedCategoryScoreDto extends DemographicBreakdownDto {
  categoryName: string;      // "ambiente de trabajo"
  averageScore: number;      // 9.43
  totalRespondents: number;  // 87
  rating: string;            // "Muy alto"
}
export type CategoryScoresApiResponse = AggregatedCategoryScoreDto[];

/** /analysis/domain-scores */
export interface AggregatedDomainScoreDto extends DemographicBreakdownDto {
  domainName: string;        // "carga de trabajo"
  averageScore: number;
  totalRespondents: number;
  rating: string;            // "Muy alto"
}
export type DomainScoresApiResponse = AggregatedDomainScoreDto[];

/** /analysis/dimension-scores */
export interface AggregatedDimensionScoreDto extends DemographicBreakdownDto {
  dimensionName: string;     // "carga mental"
  averageScore: number;
  totalRespondents: number;
}
export type DimensionScoresApiResponse = AggregatedDimensionScoreDto[];

/** /analysis/final-assessments */
export interface AggregatedFinalAssessmentDto extends DemographicBreakdownDto {
  finalAssessment: string;   // "Alto" | "Muy alto"
  totalRespondents: number;  // 60, 27, ...
  rating: string;            // "Muy alto"
}
export type FinalAssessmentsApiResponse = AggregatedFinalAssessmentDto[];

/* =========================
 *  ERRORES (si tu API los usa)
 * ========================= */
export interface FieldErrorDto {
  field: string;
  code: string;
  message: string;
}
export interface ErrorResponseDto {
  status: number;
  error: string;
  message: string;
  timestamp: string;
  path?: string;
  fieldErrors?: FieldErrorDto[];
}

// Diccionario de correcciones
  export const DOMAIN_NAME_MAP: Record<string, string> = {
    "acontecimiento traumatico": "Acontecimiento traumático",
    "afectacion": "Afectación",
    "evitacion": "Evitación",
    "recuerdos persistentes": "Recuerdos persistentes",
    "acontecimiento traumatico severo": "Acontecimiento traumático severo",
    "organizacion del tiempo de trabajo": "Organización del tiempo de trabajo",
    "interferencia en la relacion trabajo familia" : "Interferencia en la relación trabajo-familia",
    "reconocimiento del desempeno": "Reconocimiento del desempeño",
  };

export function normalizeDomainName(name: string): string {
    return DOMAIN_NAME_MAP[name] || name;
  }
